import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium, {Style} from 'radium';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';

import * as styles from '../../../styles';
import PaginatedContainer from '../../../paginator/paginated_container';
import {request} from '../../../containers/actions';
import { host_v2 } from '../../../utilities/requests';
export default class SchoolManagerReportConsolidate extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {
        class: 'school',
        className: window.gettext('School'),
    }

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}


    filtersSelector = createSelector.bind(this)(
        [
            props => props.examination.id,
            props => props.school,
            (props, state) => state.class,
        ],
        (examination, school, class_) => [
            {field: 'examination', value: examination},
            ...class_ === 'school'
                ? [{field: 'school', value: school}]
                : [{field: 'class', value: class_}],
            {field: 'field', value: ['rank', 'score', 'taraz'].join(',')},
            {field: 'entity_type', value: 'student'},
            {field: 'group_type', value: [class_ === 'school' ? 'school' : 'class,school', 'null'].join(',')},
        ],
    )
    listFieldsSelector = createSelector(
        [
            (_, state) => state.currentTab,
            context => context.user.id,
        ],
        currentTab => [
            ...this.context.user.hasPerm('examination.reports')
                ? [{ field: 'id', label: window.gettext('ID') }]
                : [],
            {
                field: item =>item?.rank?.global_ ? item?.rank?.global_.persian() : "-",
                label: window.gettext('Rank'),
                sort: '.rank.category.all.global',
            },
            {
                field: item => `${item?.firstname} ${item?.lastname}`,
                label: window.gettext('Name'),
                sort: 'firstname',
            },

            {
                field: item => this.context.user.hasPerm('admin') ?
                    <span> {item?.school?.name ?? "-"} </span>
                    : null,
                label: "مدرسه",
            },
            {
                field: item => `${item?.username?.persian() ?? "-"}`,
                label: window.gettext('username') ,
                sort:  'username',
            },
            {
                field: item => item.score ? item.score.toPercent().persian(true) : "-",
                label: window.gettext('Score'),
                sort: `.score.category.all.global`,
            },
            {
                field: item => item.taraz ? item.taraz.toFixed().persian() : "-",
                label: window.gettext('Taraz'),
                sort: '.taraz.category.all.global',
            },
            ..._.map(this.props.examination.materials, (material , index) => ({
                fields:item => [
                    ()=> item?.materials?.[material.id].score ? item?.materials?.[material?.id]?.score?.toPercent().persian(): "-" ,
                    ()=> item?.materials?.[material.id]?.rank?.global_ ? item.materials?.[material?.id]?.rank?.global_.persian() : "-" ,
                    ()=> item?.materials?.[material.id]?.taraz ? item.materials?.[material?.id]?.taraz.toFixed().persian() : "-" ,
                 ], 
                label: material.title,
                sort: `.rank.material.${material.id}.global`,
                labels: [
                    {
                        label: window.gettext('Score'),
                        sort: `.rank.material.${material.id}.global`,
                    },
                    {
                        label: window.gettext('Rank'),
                        sort: `.rank.material.${material.id}.global`,
                    },
                    {
                        label: window.gettext('Taraz'),
                        sort: `.rank.material.${material.id}.global`,
                    },
                ],
            })),
        ],
    )

    sortsSelector = createSelector(
        [
            (props, state) => state.class,
            props => props.examination.id,
        ],
        class_ => [
            {name: '.rank.category.all.global', label: window.gettext('Rank'), reversed: true},
            {name: 'firstname', label: window.gettext('firstname')},
            {name: 'lastname', label: window.gettext('lastname')},
            {name: '.score.category.all.global', label: window.gettext('Score')},
            {name:".taraz.category.all.global" ,label:window.gettext('Taraz')},
            ..._.map(
                this.props.examination.materials,
                material => ({name:`.rank.material.${material.id}.global`, label: material.title}),
            ),
        ],
    )
    componentDidMount() {
        if (this.props.school)
            this.fetchSchool.bind(this)(this.props.school);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.school !== this.props.school) {
            this.fetchSchool.bind(this)(nextProps.school);
            this.setState({
                class: 'school',
                className: window.gettext('School'),
            });
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        if (!prevState.print && this.state.print) {
            window.scrollTo(0, 0);
            await window.wait();
            window.print();
            this.setState({print: false});
        }
    }
    
    async fetchReport(school, examination) {
        if (!school || !examination || !examination.id) {
            this.setState({data: undefined});
            return;
        }
        this.setState({data: null});
        const response = await this.context.store.dispatch(request({
            path: `/examination/${examination.id}/report/school/manager/`,
            body: {school},
        }));
        debugger;
        var newRows = response.rows.sort((a, b) => a[0].global_rank - b[0].global_rank);
        response.rows = newRows;
        this.setState({
            data: response,
        });
    }

    async fetchSchool(school) {
        if (!school) {
            this.setState({school: undefined});
            return;
        }
        this.setState({school: null});
        const response = await this.context.store.dispatch(request(`/school/${school}/`));
        this.setState({school: response});
    }

    render() {
        console.log(this.props.examination)
        if (!this.state.school)
            return null;
        const materials = this.props.examination.materials.length + (this.props.examination.special_general ? 2 : 0);
        return <div style={{display: 'flex', flexDirection: 'column', flex: '1'}}>
            <div style={{marginBottom: '.5em', marginTop: '.75em'}}>
                <button
                    key='print'
                    style={{...styles.defaultButton, backgroundColor: styles.fourthColor, float: 'left'}}
                    onClick={async () => {
                        if (this.props.school && this.props.examination && this.props.examination.id) {
                            await this.fetchReport.bind(this)(this.props.school, this.props.examination);
                            this.setState({print: true});
                        }
                    }}>
                    {window.gettext('Print')}
                </button>&nbsp;
                {window.gettext('Choose class')}:&nbsp;
                {_.map(this.state.school.classes, ({name, id}) => <button
                    key={id}
                    style={{
                        ...(this.state.class === Number.parseInt(id)
                            ? styles.activeButton
                            : styles.button),
                        marginLeft: '.5em',
                    }}
                    onClick={() => this.setState({class: Number.parseInt(id), className: window.gettext('Class')})}>
                    {(name || window.gettext('No Name')).persian()}
                </button>)}
                <button
                    style={this.state.class === 'school' ? styles.activeButton : styles.button}
                    onClick={() => this.setState({class: 'school', className: window.gettext('School')})}>
                    {window.gettext('School')}
                </button>
            </div>
            {this.state.school
                ? <div
                    style={{
                        ...styles.box,
                        width: '100%',
                        overflow: 'hidden',
                    }}>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Examination')}: {this.props.examination.title}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('School Name')}: {this.state.school.name}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('City')}: {this.state.school.city.name}
                    </div>
                    {/* <div style={{float: 'right', width: '25%'}}> */}
                    {/*     {window.gettext('Grade')}: {this.state.data.grade_display} */}
                    {/* </div> */}
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Holding Date')}: {this.props.examination.date ? this.props.examination.date.toJalali().persian() : ''}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Analyze Date')}: {this.props.examination.analyze_date
                            ? this.props.examination.analyze_date.toJalali().persian()
                            : ''
                        }
                    </div>
                    {/* <div style={{float: 'right', width: '25%'}}> */}
                    {/*     {window.gettext('Centers Participated')}: {(this.state.data.centers || '').persian()} */}
                    {/* </div> */}
                    {/* <div style={{float: 'right', width: '25%'}}> */}
                    {/*     {window.gettext('Participants')}: {(this.state.data.participants || '').persian()} */}
                    {/* </div> */}
                    <div style={{clear: 'right', textAlign: 'center', fontWeight: '700'}}>
                        {window.interpolate(
                            window.gettext('Ranks are based on %(analyzeModel)s!'),
                            {analyzeModel: this.props.examination.analyze_model === 1 ? window.gettext('Taraz') : window.gettext('Score')},
                            true,
                        )}
                    </div>
                </div>
                : null
            }
            {this.state.print
                ? <span class='media-print-display'>
                    <div
                        style={{
                            position: 'absolute',
                            top: '21mm',
                            right: '61mm',
                            width: '52mm',
                            fontSize: '1.65em',
                        }}>
                        <div style={{textAlign: 'center'}}>
                            <b>{window.gettext('Manager Report')}</b>
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '9mm',
                            right: '127mm',
                            width: '63.2mm',
                        }}>
                        <div style={{overflow: 'hidden', height: '2.3em'}}>
                            <b>{window.gettext('School Name')}:</b>&nbsp;
                            {this.state.data.school_display} - {this.state.data.city_display}
                        </div>
                        <div style={{overflow: 'hidden', height: '2.3em'}}>
                            <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                            {this.props.examination.title} - {this.state.data.grade_display}
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '9mm',
                            right: '202mm',
                            width: '42mm',
                        }}>
                        <div style={{overflow: 'hidden', height: '2.3em'}}>
                            <b>{window.gettext('Holding Date')}:</b> {this.props.examination.date
                                ? this.props.examination.date.toJalali().persian('YYYY/MM/DD')
                                : ''
                            }
                        </div>
                        <div style={{overflow: 'hidden', height: '2.3em'}}>
                            <b>{window.gettext('Participants')}:</b> {(this.state.data.participants || '').persian()}
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '9mm',
                            right: '254mm',
                            width: '34mm',
                        }}>
                        <div style={{overflow: 'hidden', height: '2.3em'}}>
                            <b>{window.gettext('Centers Participated')}:</b> {(this.state.data.centers || '').persian()}
                        </div>
                        <div style={{overflow: 'hidden', height: '2.3em'}}>
                            <b>{window.gettext('Rank Among Schools')}:</b> {(this.state.data.school_rank || '').persian()}
                        </div>
                    </div>
                    {/* <div */}
                    {/*     style={{ */}
                    {/*         position: 'fixed', */}
                    {/*         top: '195mm', */}
                    {/*         right: '16mm', */}
                    {/*         width: '71mm', */}
                    {/*     }}> */}
                    {/*     <div style={{overflow: 'hidden', height: '2.3em'}}> */}
                    {/*         <b>{window.gettext('Analyze Date')}:</b> {(this.props.examination.analyze_date || '').persian()} */}
                    {/*     </div> */}
                    {/* </div> */}
                    {/* <div */}
                    {/*     style={{ */}
                    {/*         position: 'fixed', */}
                    {/*         top: '195mm', */}
                    {/*         right: '120mm', */}
                    {/*         fontSize: '1.3em', */}
                    {/*         fontFamily: 'Arial', */}
                    {/*     }}> */}
                    {/*     <b>www.mhelli.ir</b> */}
                    {/* </div> */}
                    <Style
                        rules={{
                            '@page': {
                                size: 'A4 Landscape',
                                marginTop: '0',
                                marginLeft: '0',
                                marginRight: '0',
                                marginBottom: '17mm',
                            },
                            mediaQueries: {
                                print: {
                                    '*': {
                                        backgroundColor: 'unset !important',
                                    },
                                    body: {
                                        visibility: 'hidden',
                                    },
                                    '.page': {
                                        minHeight: 'unset',
                                    },
                                },
                            },
                        }}>
                    </Style>
                </span>
                : null
            }
            <div
                style={{
                    ..._.pickBy(styles.box, (_, key) => key != 'padding'),
                    marginTop: '1em',
                    marginBottom: '1em',
                    fontSize: `${1 - Math.max(_.size(this.props.examination.materials) - 6, 0) * .04}em`,
                    overflowX: 'scroll',
                    flex: '1',
                    paddingTop: '.5em',
                    paddingLeft: '1em',
                    paddingRight: '1em',
                }}>

                <PaginatedContainer
                    store={this.props.examinationStudents}
                    resource='consolidated_report'
                    style={this.style}
                    listFields={this.listFieldsSelector(this.context, this.state)}
                    tooltip={null}
                    title={this.props.title}
                    selectable
                    events={{onClick: item => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + item.id + '/',
                    ))}}
                    filters={this.filtersSelector(this.props, this.state)}
                    sorts={this.sortsSelector(this.props, this.state)}
                    pageSize={30}
                />
                {this.state.print
                ? <div class='media-print-display school-manager-media-print' >
                    <table
                        style={{
                            ...styles.table,
                            fontSize: materials > 8
                                ? `${Math.pow(.93, materials - 7)}em`
                                : '1em',
                        }}>
                        <thead>
                            <tr style={{height: '34mm', border: 'none'}}/>
                            <tr>
                                <th rowSpan='2' style={{...styles.th, width: '3em'}}>
                                    {window.gettext('Rank')}
                                </th>
                                <th rowSpan='2' style={{...styles.th, width: '15em'}}>
                                    {window.gettext('Name')}
                                </th>
                                <th
                                    rowSpan='2'
                                    style={{...styles.th, width: '4em'}}>
                                    {window.gettext('Score')}
                                </th>
                                <th
                                    rowSpan='2'
                                    style={{...styles.th, width: '4em'}}>
                                    {window.gettext('Taraz')}
                                </th>
                                <th
                                    rowSpan='2'
                                    style={{...styles.th, width: '3em'}}>
                                    {window.gettext('Rank')}
                                </th>
                                {this.props.examination.special_general
                                    ? _.map(
                                        _.uniq(_.values(this.props.examination.materials_types)),
                                        materialType => <th
                                            key={materialType}
                                            colSpan='2'
                                            style={{
                                                ...styles.th,
                                                unicodeBidi: 'plaintext',
                                                width: '5em',
                                                fontSize: styles.th.fontSize,
                                            }}>
                                            {materialType === '1'
                                                ? window.gettext('General')
                                                : window.gettext('Special')
                                            }
                                        </th>,
                                    )
                                    : null
                                }
                                {_.map(
                                    this.props.examination.materials,
                                    material => <th
                                        key={material.id}
                                        colSpan='2'
                                        style={{
                                            ...styles.th,
                                            unicodeBidi: 'plaintext',
                                            width: '5em',
                                            fontSize: materials > 6
                                                ? `${Math.pow(.96, (material.title.length - 6))}em`
                                                : styles.th.fontSize,
                                        }}>
                                        {material.title.length > 13 && materials > 4
                                            ? material.title.substr(0, 10) + '...'
                                            : material.title
                                        }
                                    </th>,
                                )}
                            </tr>
                            <tr>
                                {this.props.examination.special_general
                                    ? _.map(
                                        _.uniq(_.values(this.props.examination.materials_types)),
                                        materialType => [
                                            <th
                                                key={'-' + materialType + '-0'}
                                                style={{...styles.th, width: '3em'}}>
                                                {window.gettext('Score')}
                                            </th>,
                                            <th
                                                key={'-' + materialType + '-1'}
                                                style={{...styles.th, width: '2em'}}>
                                                {window.gettext('Rank')}
                                            </th>,
                                        ],
                                    )
                                    : null
                                }
                                {_.map(
                                    this.props.examination.materials,
                                    material => [
                                        <th
                                            key={material.id + '-0'}
                                            style={{...styles.th, width: '3em'}}>
                                            {window.gettext('Score')}
                                        </th>,
                                        <th
                                            key={material.id + '-1'}
                                            style={{...styles.th, width: '2em'}}>
                                            {window.gettext('Rank')}
                                        </th>,
                                    ],
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(
                                _.sortBy(
                                    _.filter(this.state.data.rows, row => this.state.class === 'school' || row.class === this.state.class),
                                    row => row[0].global_rank || row[0].global_rank,
                                ),
                                (row, index) => <tr style={styles.th} key={index}>
                                    <td style={{...styles.td, width: '3em'}}>
                                        {(index+1 || '-').persian()}
                                    </td>
                                    <td
                                        style={{
                                            ...styles.td,
                                            width: '15em',
                                            textAlign: 'right',
                                            cursor: 'pointer',
                                            color: '#4078c0',
                                            fontWeight: '500',
                                        }}>
                                        <span style={{'@media print': {color: 'black'}}}>
                                            {`${row.firstname} ${row.lastname}`}
                                        </span>
                                    </td>
                                    <td style={{...styles.td, width: '4em'}}>
                                        {row[0].score.toPercent().persian(true)}
                                    </td>
                                    <td style={{...styles.td, width: '4em'}}>
                                        {(row[0].taraz ? row[0].taraz.toFixed() : '-').persian()}
                                    </td>
                                    <td style={{...styles.td, width: '3em'}}>
                                        {(row[0].global_rank || '-').persian()}
                                    </td>
                                    {this.props.examination.special_general
                                        ? _.map(
                                            _.uniq(_.values(this.props.examination.materials_types)),
                                            materialType => [
                                                <td
                                                    key={'-' + materialType + '-score'}
                                                    style={{...styles.td, width: '3em'}}>
                                                    {row[-materialType].score.toPercent().persian(true)}
                                                </td>,
                                                <td
                                                    key={'-' + materialType + '-rank'}
                                                    style={{...styles.td, width: '2em'}}>
                                                    {(row[-materialType].rank || '-').persian()}
                                                </td>,
                                            ],
                                        )
                                        : null
                                    }
                                    {_.map(this.props.examination.materials, material => [
                                        <td
                                            key={material.id + '-score'}
                                            style={{...styles.td, width: '3em'}}>
                                            {row[material.id].score.toPercent().persian(true)}
                                        </td>,
                                        <td
                                            key={material.id + '-rank'}
                                            style={{...styles.td, width: '2em'}}>
                                            {(row[material.id].rank || '-').persian()}
                                        </td>,
                                    ])}
                                </tr>,
                            )}
                        </tbody>
                        <tfoot>
                            {/* <tr style={{height: '26mm'}}></tr> */}
                        </tfoot>
                    </table>
                </div>
                : null
            }
            </div>

        </div>;
    }
};